<ion-button
  fill="outline"
  shape="round"
  [class.selected]="isSelected"
  (click)="select()"
  expand="full"
  [disabled]="isDisabled">
  <ng-content></ng-content>
</ion-button>
